"use client"
import Image from "next/image"
import { useTranslations } from "next-intl"
import { useEffect } from "react"
import { useRouter } from "@/i18n/navigation"
import { useAppSelector } from "@/lib/store/hooks"
import { LoginForm } from "./login-form"

export const dynamic = "force-dynamic"

export default function LoginPage() {
  const t = useTranslations("auth.login")
  const router = useRouter()
  const { isAuthenticated } = useAppSelector((state) => state.auth)

  useEffect(() => {
    if (isAuthenticated) {
      router.push("/dashboard")
    }
  }, [isAuthenticated, router])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-[380px] space-y-8">
        {/* Header with Logo and Company Info */}
        <div className="space-y-4 text-center" />

        {/* Login Form */}
        <div className="space-y-6">
          <div className="flex justify-center">
            <Image
              alt={t("title")}
              className=""
              height={151}
              src="/images/Logo.png"
              width={140}
            />
          </div>
          <div className="space-y-2 text-center">
            <h1 className="font-medium text-2xl text-foreground">
              {t("title")}
            </h1>
            <p className="text-muted-foreground">{t("subtitle")}</p>
          </div>

          <LoginForm />
        </div>
      </div>
    </div>
  )
}
